import React from 'react';
import { FilteredProductList } from 'components/ProductList'

export const NewItemsPage = () => (
  <FilteredProductList />
);
